// extracted by mini-css-extract-plugin
export default {"item":"MenuItem_item__DROLf"};